import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './CategoryGroupCard.css';

interface CategoryGroupCardProps {
  category: string;
  numberFollower?: string;
  icon?: React.ReactNode;
}

export default ({ category, numberFollower }: CategoryGroupCardProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box className={styles.card} name="category-group-card">
      <Stack space="small">
        <Text align="left" size="standard" tone="neutral" weight="medium">
          {category}
        </Text>
        {Boolean(numberFollower) && Boolean(category) && (
          <Text
            align="left"
            size="xsmall"
            tone="secondary"
            weight="regular"
            id="follower"
          >
            {numberFollower} {t('followers')}
          </Text>
        )}
      </Stack>
    </Box>
  );
};
